import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60d65712"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invoice-layout" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "logo"
}
const _hoisted_7 = {
  key: 1,
  class: "ph"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "column" }, null, -1))
const _hoisted_9 = { class: "column" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("View Invoice")
const _hoisted_11 = { class: "container" }
const _hoisted_12 = {
  key: 0,
  class: "invoice"
}
const _hoisted_13 = { class: "powered is_centered" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Payments powered by ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "ml-2",
  width: "112",
  height: "11",
  viewBox: "0 0 112 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.68101 0.0150934L0 10.9318V11.0001H2.47818L3.37308 8.61203L8.12293 8.5438L9.08666 11.0001H11.6337L6.95267 0.0150934H4.68101ZM7.22804 6.3604H4.33683L5.7136 2.88069L7.22804 6.29217V6.3604ZM92.1746 0.0150934L87.4935 10.9318V11.0001H89.9717L90.8666 8.61203L95.6165 8.5438L96.5802 11.0001H99.1272L94.4462 0.0150934H92.1746ZM94.7216 6.3604H91.8304L93.2071 2.88069L94.7216 6.29217V6.3604ZM24.4377 0.833783C22.8736 -0.28723 19.1825 0.0266259 16.5212 0.0832566V11H18.9306V7.52029H20.8581L23.1986 11H26.0209V10.9318L23.4051 7.11091C25.6375 6.07245 26.9475 2.63163 24.4377 0.833783ZM18.9305 5.33693V2.26659C20.6962 2.20246 22.9087 1.99367 23.2673 3.35827C23.8869 5.7081 20.8139 5.40584 18.9305 5.33693ZM30.3577 2.26661H33.7308V11H36.1401V2.26661H39.5132V0.0832629H30.3577V2.26661ZM46.8789 6.56508H52.1106V4.38173H46.8789V2.26661H52.799V0.0832629H44.4696V11H52.8678V8.81666H46.8789V6.56508ZM66.1537 0.833783C64.5897 -0.28723 60.8986 0.0266259 58.2373 0.0832566V11H60.6466V7.52029H62.5741L64.9146 11H67.737V10.9318L65.1211 7.11091C67.3535 6.07245 68.6635 2.63163 66.1537 0.833783ZM60.6466 5.33693V2.26659C62.4123 2.20246 64.6247 1.99367 64.9834 3.35827C65.6029 5.7081 62.53 5.40584 60.6466 5.33693ZM80.1967 6.76982L75.1715 0.219776C74.6435 -0.025851 73.5193 0.0648944 72.7621 0.0833164V11.0001H75.1715V4.10887L80.472 11.0001H82.606V0.0833164H80.1967V6.76982ZM106.493 8.81666V0.0832629H104.084V11H112V8.81666H106.493Z",
    fill: "#333333"
  })
], -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

import { ref } from 'vue'
import { store } from '@/store'
import { useRoute } from 'vue-router'
import InvoiceNotFound from '@/pages/invoice/InvoiceNotFound.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceLayout',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute()
const invoiceNotFound = ref<boolean>(false)
const showDownloadButton = ref<boolean>(false)
const invoice = ref()

const logoUrl = ref()
const websiteUrl = ref()
const organization = ref()

if (route.params.uuid) {
  try {
    (
  ([__temp,__restore] = _withAsyncContext(() => store.dispatch('getInvoice', route.params.uuid))),
  await __temp,
  __restore()
)
  } catch (err) {
    invoiceNotFound.value = true
  }

  showDownloadButton.value = route.name !== 'Invoice'
  invoice.value = store.state.invoice
  organization.value = store.state.organization
  logoUrl.value = store.state.logoUrl
  websiteUrl.value = store.state.websiteUrl
}

// const getDefaultRoute = (): string => {
//   let routeName = 'Invoice'
//   if (store.state.invoice.paid_status) {
//     switch (store.state.invoice.paid_status) {
//       case 'unpaid':
//         routeName = 'InvoicePaymentStatus'
//         break
//       case 'partially paid':
//         routeName = 'InvoicePartialPaymentPaid'
//         break
//       case 'paid':
//         routeName = 'InvoiceCompleted'
//         break
//     }
//   }
//   return routeName
// }

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (organization.value)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "logo",
                  to: { name: 'Invoice', params: { uuid: _unref(route).params.uuid } }
                }, {
                  default: _withCtx(() => [
                    (logoUrl.value)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: logoUrl.value,
                          alt: organization.value,
                          draggable: "false"
                        }, null, 8, _hoisted_5))
                      : (_openBlock(), _createElementBlock("h2", _hoisted_6, _toDisplayString(organization.value), 1))
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (!invoiceNotFound.value)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_7))
                : _createCommentVNode("", true)
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            (invoice.value.uuid)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "button ml-auto",
                  to: `/review/${invoice.value.uuid}`
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (!invoiceNotFound.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(_component_router_view)
          ]))
        : (_openBlock(), _createBlock(InvoiceNotFound, { key: 1 }))
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_13, [
        (organization.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Copyright © " + _toDisplayString(organization.value) + " " + _toDisplayString(new Date().getFullYear()), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_15, _hoisted_18))
      ])
    ])
  ]))
}
}

})